/**
 * Drops Aether's default interaction events from Button, Link, and Tabs when
 * they are auto-instrumented and no scope is mounted — unscoped chrome noise
 * rather than deliberate instrumentation.
 */
const DEFAULT_INTERACTION_EVENTS = new Set([
    'button selected',
    'link selected',
    'tab selected',
]);
const isAutoInstrumentedEventData = (data) => data.autoInstrumented === true;
export const unscopedDefaultsMiddleware = (event) => DEFAULT_INTERACTION_EVENTS.has(event.name) &&
    isAutoInstrumentedEventData(event.data) &&
    event.data.scopePath === undefined
    ? { state: 'stop' }
    : { state: 'continue', event };
//# sourceMappingURL=unscopedDefaultsMiddleware.js.map